import { createContext } from "react";
import { PromoCodeInfo } from "@jugl-web/rest-api/entities/models/common-types/PromoCodeInfo";
import { SubscriptionIntervalType } from "@jugl-web/rest-api/entities/models/common-types/SubscriptionIntervalType";
import { SubscriptionPlanModel } from "@jugl-web/rest-api/entities/models/SubscriptionPlan/SubscriptionPlanModel";

export interface SelectSubscriptionFormContextValue {
  additionalSeats: number;
  updateAdditionalSeats: () => void;

  selectedPlan: SubscriptionPlanModel | undefined;
  selectPlan: (plan: SubscriptionPlanModel) => void;

  selectedSubscriptionInterval: SubscriptionIntervalType;
  selectSubscriptionInterval: (interval: SubscriptionIntervalType) => void;

  confirmPurchase: () => void;

  appliedPromoCodes: PromoCodeInfo[];
  addPromoCode: (promoCode: PromoCodeInfo) => void;
  removePromoCode: (idx: number) => void;

  isDealMirrorMode: boolean;

  plans: SubscriptionPlanModel[] | undefined;
  plansIsLoading: boolean;
  plansIsError: boolean;
  plansRefetch: () => void;

  defaultCurrency: string;
}

export const SelectSubscriptionFormContext =
  createContext<SelectSubscriptionFormContextValue | null>(null);
